<div class="w-100 h-100 register-container">

    <div class="container h-100">
        <div class="row py-5 mt-3 align-items-center h-100">
            <!-- For Demo Purpose -->
            <div class="col-md-5 pe-lg-5 mb-5 mb-md-0 text-area">
                <h1>Start your journey<br/> with Automated engineering </h1>
                <p class="font-italic text-muted mb-0">Discover the best automated engineering system.</p>
                
            </div>
    
            <!-- Registeration Form -->
            <div class="col-md-7 col-lg-6 ml-auto" *ngIf='!viewConfirm'>
                <div class="d-flex justify-content-center align-items-center mb-3 w-100">
                    <img width="250" src="../../../../assets/images/logo-2.png" alt="" />
                </div>
                <div class="d-flex justify-content-center align-items-center mb-5 w-100 automate">
                    <div>Automate Your Engineering</div>
                </div>
                
                <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
                    <div class="row">
    
                        <!-- First Name -->
                        <div class="input-group col-lg-6 mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-user text-muted"></i>
                                </span>
                            </div>
                            <input id="firstName" type="text" formControlName="firstname" placeholder="First Name *" 
                                class="form-control bg-white border-left-0 border-md">
                        </div>
    
                        <!-- Last Name -->
                        <div class="input-group col-lg-6 mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-user text-muted"></i>
                                </span>
                            </div>
                            <input id="lastName" type="text" formControlName="lastname" placeholder="Last Name"
                                class="form-control bg-white border-left-0 border-md">
                        </div>
    
                        <!-- Email Address -->
                        <div class="input-group has-validation col-lg-12"
                        [ngClass]="{'mb-4': !(userForm.controls.userName.errors?.email && (userForm.controls.userName.dirty || userForm.controls.userName.touched)),
                        'mb-2': userForm.controls.userName.errors?.email && (userForm.controls.userName.dirty || userForm.controls.userName.touched)}">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-envelope text-muted"></i>
                                </span>
                            </div>
                            <input id="email" type="email" formControlName="userName" placeholder="Email Address / Username *" 
                            [class.validation-error]="userForm.controls.userName.invalid && (userForm.controls.userName.dirty || userForm.controls.userName.touched)"
                                class="form-control bg-white border-left-0 border-md">
                                <div class="d-block w-100 mt-1" *ngIf="userForm.controls.userName.errors?.email && (userForm.controls.userName.dirty || userForm.controls.userName.touched)">
                                    <p class="mb-0 text-danger">Enter a valid email address.</p>
                                </div>
                        </div>
    
                        <!-- Phone Number -->
                        <div [ngClass]="{'mb-4': !(userForm.get('phone').errors?.notNumber && userForm.get('phone').touched)}" class="input-group col-lg-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-phone-square text-muted"></i>
                                </span>
                            </div>
                            <select id="countryCode" formControlName="countryCode" style="width: fit-content; flex-grow: 0;"
                            [class.validation-error]="userForm.controls.countryCode.invalid 
                                                        && (userForm.controls.countryCode.dirty || userForm.controls.countryCode.touched)"
                                class="custom-select form-control bg-white border-left-0 border-md h-100 fw-bold text-muted">
                                <option *ngFor="let country of countries"  [value]="country.code">({{ country.code }}) {{ country.name }}</option>
                            </select>
                            <input id="phoneNumber" type="tel" formControlName="phone" placeholder="Phone Number *"  maxlength="12"
                                class="form-control bg-white border-md border-left-0 ps-3"
                                [class.validation-error]="userForm.controls.phone.invalid && (userForm.controls.phone.dirty || userForm.controls.phone.touched)">
                        </div>
                        <div class="col d-block mt-1 mb-2 text-danger"  *ngIf="userForm.get('phone').errors?.notNumber && userForm.get('phone').touched">
                            Please enter a valid Phone number.
                        </div>
                        
    
                        <!-- Company -->
                        <div class="input-group col-lg-12 mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-university text-muted"></i>
                                </span>
                            </div>
                            <input id="company" formControlName="company" placeholder="Company *"
                            [class.validation-error]="userForm.controls.company.invalid && (userForm.controls.company.dirty || userForm.controls.company.touched)"
                                class="form-control bg-white border-left-0 border-md">
                        </div>
    
                        <div class="input-group col-lg-12 mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-white px-4 border-md border-right-0">
                                    <i class="fa fa-id-card-o text-muted"></i>
                                </span>
                            </div>
                            <input id="company" formControlName="companyRegistrationNumber" placeholder="Company Registration Number"
                                class="form-control bg-white border-left-0 border-md">
                        </div>
    
                        <div class="input-group col-lg-12 mb-4 terms-and-conditions">
                            <div class="">	
                                By clicking create your account, you agree to our &nbsp;<a (click)="openTermsAndCondition()">Terms and Conditions</a>  
                             </div>
                        </div>
    
                        
    
                        <!-- Submit Button -->
                        <div class="form-group col-lg-12 mx-auto mb-0">
                            <button type="submit" class="btn btn-primary submit-btn btn-block py-2" [disabled]="!userForm.valid || apiCall">
                                <span class="fw-bold">{{apiCall ? 'Processing ...' : 'Create your account'}}</span>
                            </button>                        
                        </div>
                        <div class="col-lg-12 mb-4">
                            <div *ngIf="showErrorMessage" class="text-danger">
                                    {{message}}
                            </div>
                        </div>
    
                        <!-- Divider Text -->
                        <div class="form-group col-lg-12 mx-auto d-flex align-items-center my-4">
                            <div class="border-bottom w-100 ms-5"></div>
                            <span class="px-2 small text-muted fw-bold text-muted">OR</span>
                            <div class="border-bottom w-100 me-5"></div>
                        </div>
    
                        <!-- Already Registered -->
                        <div class="text-center w-100 create-account">
                            <p class="fw-bold">Already Registered ? <a routerLink="/"
                                    class="color-secondary ms-2">Login</a></p>
                        </div>
    
                    </div>
                </form>
            </div>
            <div class="col-md-7 col-lg-6 ml-auto" *ngIf='viewConfirm'>
                <div class="row">
                    <div class="col-md-12">
                        <h1>Confirm your email</h1>
                        <p class="font-italic text-muted mb-0">We have sent you an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
